// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_18321","list":"_1411"};